import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';
import { useAuth, startGoogleLogin } from '../hooks/useAuth';

const DRESSING_IMG = 'https://customer-assets-agu9un31.emergentagent.net/job_precision-agencement/artifacts/d96e68e233e76bde_image.png';

export const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

const PERKS = ['Enregistrez autant de configurations que vous le souhaitez', 'Reprenez vos projets sur mobile, tablette ou ordinateur', 'Suivez l\'avancement de vos demandes auprès de nos architectes'];

export default function ClientLogin() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (user) navigate('/mon-espace', { replace: true }); }, [user, navigate]);

  return (
    <div className="min-h-screen bg-[#121212] grid lg:grid-cols-2" data-testid="client-login-page">
      <div className="relative hidden lg:block overflow-hidden">
        <img src={DRESSING_IMG} alt="Dressing JENMA Concept" className="absolute inset-0 w-full h-full object-cover scale-105 animate-in fade-in zoom-in-95 duration-1000" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/20 to-[#121212]" />
        <p className="absolute bottom-10 left-10 font-playfair italic text-3xl text-white/90 max-w-sm leading-snug">« Chaque détail compte, chaque espace raconte une histoire. »</p>
      </div>
      <div className="flex flex-col justify-center px-6 sm:px-16 py-12 lg:py-16">
        <div className="lg:hidden relative h-48 -mx-6 sm:-mx-16 -mt-12 mb-10 overflow-hidden">
          <img src={DRESSING_IMG} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-[#121212]" />
        </div>
        <a href="/" className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gray-500 hover:text-gold mb-10 lg:mb-16 transition-colors self-start" data-testid="client-login-back"><ArrowLeft className="w-4 h-4" />Retour au site</a>
        <p className="text-[11px] uppercase tracking-[0.4em] text-gold mb-5 flex items-center gap-3"><span className="w-10 h-px bg-gold" />Espace client</p>
        <h1 className="font-playfair text-4xl sm:text-5xl text-white leading-tight mb-6">Votre atelier <em className="text-[#d9c3a0]">personnel</em></h1>
        <ul className="space-y-3 mb-10">
          {PERKS.map((p) => <li key={p} className="flex items-start gap-3 text-gray-400 text-sm"><Check className="w-4 h-4 text-neon mt-0.5 shrink-0" />{p}</li>)}
        </ul>
        <button type="button" onClick={() => startGoogleLogin('/mon-espace')} data-testid="client-google-login-btn"
          className="group w-full sm:w-auto sm:self-start sm:min-w-[320px] inline-flex items-center justify-center gap-3 bg-white hover:bg-[#f4f1ea] text-[#1a1a1a] font-semibold px-8 py-4 transition-colors duration-300 shadow-2xl">
          <GoogleIcon /> Continuer avec Google
        </button>
        <p className="text-xs text-gray-500 mt-6 max-w-sm">La connexion est facultative : le configurateur reste librement accessible. Elle sert uniquement à enregistrer et retrouver vos projets.</p>
      </div>
    </div>
  );
}
